import {ConfEnv} from "../../config/config";
import privateRequest from "../../Infra/http/private.request";

// Persists the user's Chilean RUT on Keycloak (attribute `nationalID_CL`).
// The backend rejects the call once the attribute is set — RUTs are write-once.
// `attributeValue` should be the cleaned RUT, e.g. "123456785" or "12345678K";
// the server normalizes again before storing.
export const registerChileanRUTService = async attributeValue => {
  return privateRequest.put(ConfEnv.API_URL.URL_UPDATE_CHILEAN_RUT, {
    attribute_value: attributeValue,
  });
};
